import React from "react";
import styled from "styled-components";
import { useGetWebsiteConfigQuery } from "../services/o1Core";

const Timeline = (props) => {
  const { data, isSuccess } = useGetWebsiteConfigQuery({
    program: "super40",
  });

  const downloadTxtFile = () => {
    const element = document.createElement("a");
    const file = new Blob([document.getElementById("input").value], {
      type: "text/plain;charset=utf-8}",
    });
    element.href = "../Assets/one.csv";
    element.download = "one.csv";
    element.click();
  };

  return (
    <TimeLineStyled>
      <h3 className="heading-desktop">How to Apply</h3>
      <div className="timeline">
        <div className="container left">
          <div className="content">
            <h2 style={{ marginLeft: 10 }}>Transfer Fees</h2>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <p>{props.data.timeline.first}</p>
              <span>
                <button className="btn-giveTest mobileres">
                  <a
                    rel="noreferrer"
                    href={
                      props.data.programName === "Super40" && isSuccess
                        ? data?.value?.qrCode || require("../Assets/QR_new.pdf")
                        : require("../Assets/QR_new.pdf")
                    }
                    target="_blank"
                    // href={require("../Assets/QR_new.pdf")}
                    // download={"QR_Code"}
                  >
                    QR Code
                  </a>
                </button>
              </span>
            </div>
          </div>
          {/* <iframe
            src={require("../Assets/QRCode_Catalysing.png")}
            frameborder="0"
            width="600rem"
            height="500rem"
            style={{
              display: showQR ? "" : "none",
              backgroundColor: "red",
              WebkitTransform: "scale(0.8)",
            }}
          /> */}
        </div>

        <div className="container right">
          <div className="content">
            <h2 style={{ marginLeft: 10 }}>Fill Registration form</h2>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <p>
                {props.data.timeline.second}
                <br></br>
              </p>
              <a
                href={
                  props.data.programName === "Super40" && isSuccess
                    ? data?.value?.registrationForm ||
                      props.data.timelineformlink
                    : props.data.timelineformlink
                }
                rel="noreferrer"
                className="explore-btn "
                target="_blank"
              >
                <button className="btn-giveTest mobileres">
                  Application Form
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </TimeLineStyled>
  );
};

export default Timeline;

const TimeLineStyled = styled.div`
  a {
    text-decoration: none;
    color: black;
  }
  .heading-desktop {
    margin: 2rem 0;
    text-align: center;
    font-size: 2.5rem;
    color: white;
    margin-bottom: 1rem;
  }

  .timeline {
    position: relative;
    max-width: 1200px;
    margin: 0 auto;
  }

  /* The actual timeline (the vertical ruler) */
  .timeline::after {
    content: "";
    position: absolute;
    width: 6px;
    background-color: white;
    top: 0;
    bottom: 0;
    left: 50%;
    margin-left: -3px;
  }

  /* Container around content */
  .container {
    padding: 10px 40px;
    position: relative;
    background-color: inherit;
    width: 50%;
  }

  /* The circles on the timeline */
  .container::after {
    content: "";
    position: absolute;
    width: 25px;
    height: 25px;
    right: -17px;
    background-color: white;
    border: 4px solid #ff9f55;
    top: 15px;
    border-radius: 50%;
    z-index: 1;
  }

  /* Place the container to the left */
  .left {
    left: 0;
  }

  /* Place the container to the right */
  .right {
    left: 50%;
  }

  /* Add arrows to the left container (pointing right) */
  .left::before {
    content: " ";
    height: 0;
    position: absolute;
    top: 22px;
    width: 0;
    z-index: 1;
    right: 30px;
    border: medium solid white;
    border-width: 10px 0 10px 10px;
    border-color: transparent transparent transparent white;
  }

  /* Add arrows to the right container (pointing left) */
  .right::before {
    content: " ";
    height: 0;
    position: absolute;
    top: 22px;
    width: 0;
    z-index: 1;
    left: 30px;
    border: medium solid white;
    border-width: 10px 10px 10px 0;
    border-color: transparent white transparent transparent;
  }

  /* Fix the circle for containers on the right side */
  .right::after {
    left: -16px;
  }

  /* The actual content */
  .content {
    padding: 1rem;
    background-color: white;
    position: relative;
    border-radius: 6px;
    font-size: 0.9rem;
  }
  .content p {
    font-size: 1rem;
    padding: 0.2rem 0.4rem;
  }
  .content h2 {
    padding: 0.2rem 0.7rem;
    font-size: 1.32rem;
  }
  .btn-giveTest {
    background: rgba(0, 0, 0, 0)
      linear-gradient(90deg, rgb(229, 0, 255) 0%, rgb(130, 0, 255) 100%) repeat
      scroll 0% 0%;
    font-family: "Poppins";
    margin-top: 0.9rem;
    margin-right: 0.6rem;
    text-transform: uppercase;
    height: auto;
    color: white !important;
    transition: all ease 0.5s;
    text-decoration: none;
    white-space: normal;
    width: initial !important;
    text-align: center;
    /* line-height: 35px; */
    letter-spacing: 2px;
    font-weight: 500;
    font-size: 14px;
    box-shadow: rgb(103 0 255 / 40%) 0px 10px 60px 0px;
    padding: 4px 26px;
    padding: 4px 14px;
    border-radius: 300px;
    /* filter: brightness(100%); */
    visibility: visible;
    cursor: pointer;
  }

  /* Media queries - Responsive timeline on screens less than 600px wide */
  @media screen and (max-width: 600px) {
    .mobileres {
      transform: scale(0.7);
    }

    /* Place the timelime to the left */

    .timeline::after {
      left: 31px;
    }

    .content p {
      font-size: 0.7rem;
      padding: 0.2rem 0.4rem;
    }
    .content h2 {
      padding: 0.2rem 0.7rem;
      font-size: 1rem;
    }
    /* Full-width containers */
    .container {
      width: 100%;
      padding-left: 70px;
      padding-right: 25px;
    }

    /* Make sure that all arrows are pointing leftwards */
    .container::before {
      left: 60px;
      border: medium solid white;
      border-width: 10px 10px 10px 0;
      border-color: transparent white transparent transparent;
    }

    /* Make sure all circles are at the same spot */
    .left::after,
    .right::after {
      left: 15px;
    }

    /* Make all right containers behave like the left ones */
    .right {
      left: 0%;
    }
  }
`;
